import React, { FC } from 'react';

export const DATA_QA_STORE_GENERAL_PLAN_IMAGE = 'store-general-plan-mage';

export const StoreGeneralPlanImage: FC<{ mobile?: boolean }> = ({ mobile }) => {
  const [width, height] = mobile ? [135, 96] : [271, 194];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1280 910"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-qa={DATA_QA_STORE_GENERAL_PLAN_IMAGE}
    >
      <path fill="#fff" d="M26 763h1180V83H26z" />
      <path fill="#fff" d="M508 763h698V31H508z" />
      <path
        d="M174.5 34v35.5H19V772h599v122h96.5v-43.5H992V772h225.5V592.5h40.5v-573H497v50H380V34"
        stroke="#464C5C"
        strokeWidth="29"
      />
      <path stroke="#464C5C" strokeWidth="2" d="M189 83h176V35H189zM880 90h114V35H880z" />
      <path
        stroke="#A9ADB8"
        strokeWidth="2"
        d="M285 173h36v-19h-36zM355 173h10v-31h-10zM399 173h10v-31h-10zM443 173h10v-31h-10zM487 173h10v-31h-10zM531 173h10v-31h-10zM371 173h10v-31h-10zM415 173h10v-31h-10zM459 173h10v-31h-10zM503 173h10v-31h-10zM547 173h10v-31h-10zM889 142v10h31v-10zM852 142v10h31v-10zM815 142v10h31v-10zM778 142v10h31v-10z"
      />
      <path
        fill="#DEEFD5"
        stroke="#464C5C"
        strokeWidth="2"
        d="M32 155h157V83H32zM626 90h68V34h-68zM749 90h131V34H749z"
      />
      <path
        d="M632 880h68v-43h277v-79H632v122ZM1000 757.5h203.5V578h40.5V34h-107v114h-137v609.5Z"
        fill="#DEEFD5"
      />
      <path
        fill="#A9ADB8"
        d="M68 184h94v-10H68zM228 227h94v-10h-94zM228 251h94v-10h-94zM228 275h94v-10h-94zM228 299h94v-10h-94zM228 323h94v-10h-94zM228 347h94v-10h-94zM228 371h94v-10h-94z"
      />
      <path stroke="#464C5C" strokeWidth="2" d="M1001 577h242v-74h-242zM1001 757h91v-99h-91z" />
      <path
        stroke="#464C5C"
        strokeWidth="2"
        d="M1001 757h91v-99h-91zM1092 757h113V577h-113zM1001 183h31v-34h-31zM1032 202h31v-53h-31zM869 836h108v-77H869zM631 836h108v-77H631z"
      />
      <path stroke="#464C5C" strokeWidth="2" d="M701 836h168v-77H701z" />
      <path
        fill="#A9ADB8"
        d="M588 542h126v-12H588zM588 517h126v-12H588zM588 492h126v-12H588zM588 467h126v-12H588zM588 442h126v-12H588zM588 417h126v-12H588zM588 392h126v-12H588zM588 367h126v-12H588zM588 342h126v-12H588zM588 317h126v-12H588zM588 292h126v-12H588zM588 267h126v-12H588zM588 242h126v-12H588zM588 217h126v-12H588zM588 153h156v-12H588zM744 468h177v-12H744zM744 394h177v-12H744zM744 283h177v-12H744zM744 505h177v-12H744zM744 431h177v-12H744zM744 320h177v-12H744zM744 357h177v-12H744zM231 594v126h12V594zM267 594v126h12V594zM303 594v126h12V594zM339 594v126h12V594zM375 594v126h12V594zM411 594v126h12V594zM447 594v126h12V594zM483 594v126h12V594zM519 594v126h12V594zM555 594v126h12V594zM591 594v126h12V594zM711 594v126h12V594zM675 594v126h12V594zM747 594v126h12V594zM831 594v126h12V594zM867 594v126h12V594zM903 594v126h12V594zM951 154v385h12V154zM350 384v126h12V384zM350 224v126h12V224zM378 384v126h12V384zM378 224v126h12V224zM406 384v126h12V384zM406 224v126h12V224zM434 384v126h12V384zM434 224v126h12V224zM462 384v126h12V384zM462 224v126h12V224zM490 384v126h12V384zM490 224v126h12V224zM518 384v126h12V384zM518 224v126h12V224zM546 384v126h12V384zM546 224v126h12V224zM68 208h94v-10H68zM68 232h94v-10H68zM68 256h94v-10H68zM68 280h94v-10H68zM68 304h94v-10H68zM68 328h94v-10H68zM68 352h94v-10H68zM228 491h56v-10h-56zM68 376h94v-10H68zM228 515h56v-10h-56zM228 539h56v-10h-56zM68 529h108v-24H68zM68 567h108v-24H68zM68 605h108v-24H68zM68 643h108v-24H68zM68 681h108v-24H68zM68 719h108v-24H68zM783 611v108h24V611zM627 611v108h24V611zM939 611v108h24V611zM350 372h208v-10H350z"
      />
      <path
        stroke="#464C5C"
        strokeWidth="2"
        d="M1174 503h70v-82h-70zM1174 61h70V33h-70zM1207 97h37V61h-37zM1138 185h106v-36h-106z"
      />
      <path stroke="#464C5C" strokeWidth="2" d="M1063 327h181V149h-181z" />
      <path
        stroke="#464C5C"
        strokeWidth="2"
        d="M1138 185h106V33h-106zM1194 211h50v-26h-50zM1194 248h50v-37h-50zM1001 657V182"
      />
    </svg>
  );
};
